import Vue from 'vue'
import Vuex from 'vuex'
import GUIStore from './gui'
import APIStore from './api'
import MapStore from './map'

Vue.use(Vuex);

let store = new Vuex.Store({
  modules: {
    gui: GUIStore,
    api: APIStore,
    map: MapStore,
  },
});

export default store;
